module.exports = __webpack_public_path__ + "img/个性化推荐ico.7b13f545.png";